module.exports = __webpack_public_path__ + "static/media/04.29bd5b3d.jpg";